export default {
  title: '素材库',
  tabImage: '图片',
  tabVideo: '视频',
  upload: '上传图片',
  uploadVideo: '上传视频',
  batchGroup: '批量移动',
  batchDelete: '批量删除',
  selected: '已选',
  item: '项',
  cancelSelect: '取消选择',
  searchNamePlaceholder: '按名称搜索',
  uploadNow: '立刻上传',
  editTitle: '编辑素材',
  materialName: '素材名称',
  materialNamePlaceholder: '请输入素材名称',
  moveGroupTitle: '移动分组',
  targetGroup: '目标分组',
  selectGroupPlaceholder: '请选择分组',
  confirmDeleteSingle: '确定要删除该素材吗？',
  confirmDelete: '确定要删除选中的素材吗？',
  emptyImage: '暂无图片',
  emptyVideo: '暂无视频',
};
